/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {migrateEscalationTicket} from '../api'

export const useMutationMigrateEscalationTicket = createReactQueryMutationHook('migrateEscalationTicket', migrateEscalationTicket)
